module.exports = __webpack_public_path__ + "img/return-flow-md.7499aff1.svg";